import { ACTIVE_ITEMS } from '@constants/activeItems';
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel } from '@mui/material';
import { RootContext } from 'components/RootContainer';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { LIMIT_ITEMS_SELECT } from '../../../../@constants/Pagination';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 10;

export const MarketCodeField: FC<{
  value: number[] | null;
  onChange: (value: number[] | null) => void;
  segment_market_code_ids?: number[];
}> = ({ value, onChange, segment_market_code_ids }) => {
  const { t } = useTranslation('reservation');

  const {
    HotelApi: { settings: SettingsService },
  } = useContext(RootContext);

  const { isLoading, data } = useQuery({
    queryKey: ['get-market-codes'],
    queryFn: () => {
      return SettingsService.reservation.marketCode.getAll({
        search: [ACTIVE_ITEMS],
        limit: LIMIT_ITEMS_SELECT,
      });
    },
  });

  const handleChange = (marketCodeTypeId: number) => {
    if (marketCodeTypeId === ('all' as unknown as number)) {
      onChange(null);
      return;
    }

    const currentValues = value ?? [];
    const newValues = currentValues.includes(marketCodeTypeId)
      ? currentValues.filter(id => id !== marketCodeTypeId)
      : [...currentValues, marketCodeTypeId];

    onChange(newValues.length > 0 ? newValues : null);
  };

  if (isLoading) {
    return <>...</>;
  }

  return (
    <Box
      sx={{
        boxShadow: 'inset 0 -1px 0 0 #d2d7de',
        pb: 2,
      }}
    >
      <FormControl variant="standard" fullWidth>
        <InputLabel shrink>Market code</InputLabel>
        <Box
          sx={{
            mt: 3,
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            overflow: 'auto',
          }}
        >
          <FormGroup
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={!value}
                  onChange={() => handleChange('all' as unknown as number)}
                  sx={{ mr: 1 }}
                />
              }
              label={t('list.filter.all')}
              sx={{ py: 0.5, pl: 1.5 }}
            />
            {(data || [])
              ?.filter(item => {
                if (segment_market_code_ids) {
                  return segment_market_code_ids.includes(item.market_segment_id!);
                }
                return item;
              })
              .map(marketCodeType => (
                <FormControlLabel
                  key={marketCodeType.id}
                  control={
                    <Checkbox
                      checked={value?.includes(+marketCodeType.id!) ?? false}
                      onChange={() => handleChange(+marketCodeType.id!)}
                      sx={{ mr: 1 }}
                    />
                  }
                  label={marketCodeType.name}
                  sx={{ py: 0.5, pl: 1.5 }}
                />
              ))}
          </FormGroup>
        </Box>
      </FormControl>
    </Box>
  );
};
